export default function (element, data) {
    const selectElem = element.querySelector(".select");
    const param = data.param;
    const mode = data.mode || 'redirect';
    const redirect = data.redirect == true;
    
    selectElem.addEventListener("change", function (event) {
        let value = selectElem.value;

        if (mode == 'redirect') {
            if (!param && redirect && value) {
                window.location.href = value;
                return;
            }
    
            if (param) {
                let url = new URL(window.location.href);
        
                if (value === "" || value === "all") {
                    if (param == "year") {
                        url.searchParams.set(param, value);
                    } else {
                        url.searchParams.delete(param);
                    }
                } else {
                    url.searchParams.set(param, value);
                }
        
                window.location.href = url;
            }
        } else if (mode == 'filter') {
            applyFilter(selectElem.value);
        }
    });

    // if (mode == 'filter') {
        
    //     setTimeout(() => {
    //         const firstOption = Array.from(selectElem.options).find(opt => opt.value !== 'all');
    //         console.log(firstOption);
    //         if (firstOption) {
    //             firstOption.selected = true;
    //             applyFilter(firstOption.value);
    //         }
    //     }, 30);
    // }

    function applyFilter(value) {
        if (!param || !value) return;
        const filteredBlockId = data.filteredBlock;
        if (!filteredBlockId) return;

        const filteredItems = document.querySelectorAll(filteredBlockId + ' .item-block');
        filteredItems.forEach(item => {           
            const match = (item.dataset[param] == value || value === 'all');
            item.style.display = match ? 'flex' : 'none';
            // console.log(item, item.dataset[param], value, item.dataset[param] == value, item.style.display);
        });

        const currentBlock = document.querySelector(filteredBlockId);
        let nextBlock = currentBlock?.nextElementSibling;

        if (nextBlock && nextBlock.classList.contains('faq__list_btns')) {
            nextBlock.style.display = 'none';
        }
    }
};